import React from "react";
import { useNavigate } from "react-router-dom";
import { DATA_TOURNAMENT_CARD } from "./shared/TournametCard";

const TournamentCard = ({ city = "blitar" }) => {
  const navigate = useNavigate();

  const handleNavigate = (urlPath) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    navigate(`${city}${urlPath}`);
  };

  return (
    <div className="tournament-card-container">
      {[...DATA_TOURNAMENT_CARD].map((data, idx) => (
        <div
          onClick={() => handleNavigate(data?.urlPath)}
          key={idx}
          className="tournament-card-container__card"
        >
          <div>
            <h3>{data?.title}</h3>
            <p>Pertandingan</p>
          </div>
          <img
            src={data?.imgPath}
            className={`tournament-card-container__card__${data?.className}`}
          />
        </div>
      ))}
    </div>
  );
};

export default TournamentCard;
